export const NO_ACCESS = 'noAccess';
export const VIEW = 'view';
export const VIEW_EDIT = 'viewEdit';
export const CONTENT_OWNER = 'contentOwner';
